export class GlobalSearchResultEntry {
  label: string;
  description: string;
  section: string;
  icon: string;
  url: string;
  params: any;
  payload: any;
}
